module.exports = __webpack_public_path__ + "img/watermark-add@2x.62737fe4.png";